const homepage = {
  aboutIade: {
    title: {
      1: 'IhreApotheken.de - der Onlineshop Ihrer Lieblings-Apotheke vor Ort',
      2: 'Einfach online bestellen - Bestellung noch am selben Tag erhalten',
      3: 'Kompetent beraten - gut informiert',
      4: 'Jetzt auch als App!',
    },
    paragraph: {
      1: 'IhreApotheken.de ist der erste deutschlandweite Online-Shop für Apotheken vor Ort. Medikamente oder Beauty- und Pflegeprodukte können Sie nun ganz einfach <strong>online bei Ihrer lokalen Lieblings-Apotheke bestellen.</strong> Neben klassischen Medikamenten gegen Kopfschmerzen, homöopathischen oder pflanzlichen Arzneimitteln bietet IhreApotheken.de Ihnen ein großes Sortiment bekannter Marken, wie Vichy, Eucerin, Roche Posay, Claudalie oder CeraVe.',
      2: 'Mit nur wenigen Klicks bestellen Sie über IhreApotheken.de bei Ihrer Apotheke vor Ort. Auch <strong>Rezepte für verschreibungspflichtige Medikamente können Sie einfach und sicher einlösen.</strong> Ihre Bestellung steht innerhalb weniger Stunden zur Abholung für Sie bereit - oder Sie buchen den Botendienst und lassen sich die Medikamente nach Hause bringen.',
      3: 'Sie haben Fragen? Gerne beraten Sie die erfahrenen und kompetenten MitarbeiterInnen in ihrer Lieblings-Apotheke vor Ort. Wertvolle medizinische Informationen und unterhaltsamen <strong>Lesespaß bietet zudem die Apothekenzeitschrift my life.</strong> Die Zeitschrift erhalten Sie kostenlos in Ihrer Apotheke oder als Beilage zu Ihrer Bestellung.',
      4: 'IhreApotheken.de gibt es nun auch als App - jetzt herunterladen.',
    },
    button: 'Apoteke wählen',
    urlText: {
      1: 'Rezept einlösen',
      2: 'Medikamente bestellen',
      3: 'my life entdecken',
    },
  },
}

export default homepage
